import { getDetailsDocumentsAction } from '../redux/Reducers/detailsDocumentsReducer';
import { BASE_URL } from './BASE_URL';

export const getDetailsDocuments = () => {
  return async (dispatch) => {
    const response = await fetch(BASE_URL + 'information/details-documents/');
    const data = await response.json();
    if (response.status === 200) {
      dispatch(getDetailsDocumentsAction(data));
    }
  };
};
